module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAvUlEQVQ4jWNgGGjAyMDAwLBp06b/5Gj28/NjZIFxfH19SdK8efNmBgYGBgYmfIq+33nM8OPxC7wGsWAT/Pv1O8O1hBqGj8cvMjAwMDDwW+ozaC1oYWDm5sRQi9UFT2esgmtmYGBg+Hj8IsPTGauwugCrAV8u3SJKDKcB3DoqRInhNEAmM5yB31Ifzue31GeQyQzHagDWQGTm4WLQXd3L8P3OYwZGNlYGDjkJrJpxGgADnCqy+KRRDYAljBEIACLBLnZN9wncAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/JP.png
// module id = 1177
// module chunks = 0